import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export default (axios: AxiosInstance = baseAxios): { fetchDomainStatus: () => Promise<string>; } => ({
    fetchDomainStatus: async (): Promise<string> => {
        const response = await axios.get<{ target: string }>('/api/staff/settings/domain-status');

        return response.data.target;
    },
});
